import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InsertUpdateImportDocumnets } from '../../import-documents.model';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Button, CurrentTab, RoutePath } from 'src/app/shared/model/enum';
import { CodeCrosswalkService } from 'src/app/components/admin/code-crosswalk/code-crosswalk.service';
import { ImportDocumentsService } from '../../import-documents.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-details-tab',
  templateUrl: './details-tab.component.html',
  styleUrls: ['./details-tab.component.scss']
})
export class DetailsTabComponent implements OnInit, OnDestroy {
  /** Modal input data passed from map-tab */
  @Input() data: any;

  enumButtonName = Button;
  options = [
    { name: 'Take no mapping template action.', id: '1' },
    { name: 'Update current mapping template.', id: '2' },
    { name: 'Save as new mapping template.', id: '3' }
  ];
  selectedOption = '1';
  insertUpdateImportDocumnets = new InsertUpdateImportDocumnets();
  submit: boolean = false;
  myForm: FormGroup;
  mappingTemplateId: any = '0';
  isMappingChanged: boolean = false;
  currentTab: string = '';
  fileName: string = '';
  routeUrl: string = '';
  routePath = RoutePath;
  tabName = CurrentTab;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    public toaster: ToastrService,
    public codeCrosswalkService: CodeCrosswalkService,
    public activeModal: NgbActiveModal,
    private importDocumentsService: ImportDocumentsService,
  ) {
    this.myForm = this.formBuilder.group({
      templateName: ['', Validators.required],
      description: ['']
    });
    this.routeUrl = this.router.url;
  }

  ngOnInit(): void {
    this.initFromModalData();
  }

  ngOnDestroy(): void {
    // Cleanup if needed
  }

  /**
   * Initialize component state from the modal data input.
   */
  private initFromModalData(): void {
    if (!this.data) return;

    this.insertUpdateImportDocumnets = this.data.insertUpdateImportDocumnets
      ? JSON.parse(JSON.stringify(this.data.insertUpdateImportDocumnets))
      : new InsertUpdateImportDocumnets();

    this.currentTab = this.data.currentTab ?? '';
    this.routeUrl = this.data.routeUrl ?? this.router.url;
    this.fileName = this.data.fileName ?? '';

    this.insertUpdateImportDocumnets.templateData.isTemplateCreate = false;

    // Determine mappingTemplateId based on current tab
    if (this.currentTab === this.tabName.CODECROSSWALK_TAB) {
      this.mappingTemplateId = this.insertUpdateImportDocumnets.importCodeCrosswalkModel?.mappingTemplateId || '0';
    } else if (this.currentTab === this.tabName.IMPORT_BOM_TAB) {
      this.mappingTemplateId = this.insertUpdateImportDocumnets.importModel?.mappingTemplateId || '0';
    } else {
      this.mappingTemplateId = this.insertUpdateImportDocumnets.importCompanyModel?.mappingTemplateId || '0';
    }

    // Read whether mappings have changed from the service observable
    this.isMappingChanged = this.importDocumentsService.isMappingChanged.getValue();

    // Pre-fill form with existing template data
    this.myForm.setValue({
      templateName: this.insertUpdateImportDocumnets.templateData?.templateName ?? '',
      description: this.insertUpdateImportDocumnets.templateData?.templateDescription ?? ''
    });
  }

  // ── Modal close / cancel ────────────────────────────────────────────

  closeTab(): void {
    this.activeModal.close({ confirm: false });
  }

  close(): void {
    this.codeCrosswalkService.valuePopup.next(true);
    this.activeModal.close({ confirm: false });
  }

  // ── Save template settings & close ──────────────────────────────────

  /**
   * Validates template settings, applies the selected option,
   * and closes the modal with the configured template data.
   * No API call happens here — map-tab handles that on "Next".
   */
  insertOrShowingError(): void {
    const trimmedTemplateName = this.myForm.value.templateName.trim();

    if (trimmedTemplateName !== '' || (this.selectedOption === '1' && trimmedTemplateName === '')) {
      const val = this.insertUpdateImportDocumnets?.mappingTemplateList
        ?.map(a => a.name).includes(this.myForm.value.templateName);

      // Determine which model key to apply template option to
      let modelKey = 'importCompanyModel';
      if (this.currentTab === this.tabName.CODECROSSWALK_TAB) {
        modelKey = 'importCodeCrosswalkModel';
      } else if (this.currentTab === this.tabName.IMPORT_BOM_TAB) {
        modelKey = 'importModel';
      }

      this.applyTemplateOption(modelKey);

      // Check for duplicate template name when creating new
      const model = this.insertUpdateImportDocumnets[modelKey];
      if (model.mappingTemplateId === '0' && val && this.insertUpdateImportDocumnets.templateData.isTemplateCreate) {
        this.toaster.error('Template already exists!!!');
        return;
      }

      // Close modal with the configured template settings
      this.activeModal.close({
        confirm: true,
        templateData: {
          templateName: this.myForm.value.templateName,
          templateDescription: this.myForm.value.description,
          isTemplateCreate: this.insertUpdateImportDocumnets.templateData.isTemplateCreate,
          mappingTemplateId: model.mappingTemplateId,
        }
      });
    }
  }

  /**
   * Sets the mappingTemplateId and isTemplateCreate flag
   * based on the selected radio option.
   */
  private applyTemplateOption(modelKey: string): void {
    const model = this.insertUpdateImportDocumnets[modelKey];
    if (this.selectedOption === '1') {
      this.insertUpdateImportDocumnets.templateData.isTemplateCreate = false;
      model.mappingTemplateId = this.mappingTemplateId;
    } else if (this.selectedOption === '3') {
      model.mappingTemplateId = '0';
      this.insertUpdateImportDocumnets.templateData.isTemplateCreate = true;
    } else if (this.selectedOption === '2') {
      model.mappingTemplateId = this.mappingTemplateId;
      this.insertUpdateImportDocumnets.templateData.isTemplateCreate = true;
    }
  }

  previous(){
    if (!this.insertUpdateImportDocumnets.templateData.isTemplateCreate && this.insertUpdateImportDocumnets.importCompanyModel.mappingTemplateId && this.insertUpdateImportDocumnets.importModel.mappingTemplateId) {
      this.insertUpdateImportDocumnets.importCompanyModel.mappingTemplateId = ''
    }
  }
}

